import { Navigate } from 'react-router-dom';

import { useAuthStore, userProfileSelector } from 'modules/auth/core';

import { includes } from 'lodash';

import { PATH } from 'constants/path';

const withRole =
  (requiredRoles: string[], redirectPath?: string) =>
  (Component: React.ComponentType) =>
  ({ ...props }) => {
    const userProfile = userProfileSelector(useAuthStore.getState());

    const { role } = userProfile || {};

    const roleKey = role?.key;

    if (role && includes(requiredRoles, roleKey)) {
      return <Component {...props} />;
    }

    return <Navigate to={redirectPath ?? PATH.CLASSES} replace />;
  };

export default withRole;
